import { format } from 'date-fns';
import { DISPLAY_DATE_FORMAT_LONG } from './constants';

export const formatDate = (date: Date) => format(date, DISPLAY_DATE_FORMAT_LONG);
